import { Component, OnInit, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import * as actions from '../../core/actions/contact.actions';
import * as fromContact from '../../core/reducers/contact.reducer';
import {Router, ActivatedRoute, Params} from '@angular/router';
import { map, startWith, delay } from 'rxjs/operators';

@Component({
  selector: 'app-contact-view',
  templateUrl: './contact-view.component.html',
  styleUrls: ['./contact-view.component.scss']
})
export class ContactViewComponent implements OnInit {

  @Input() contact: any;
  @Input() full: boolean = true;

  constructor(private store: Store<any>, private activatedRoute: ActivatedRoute) { }

  ngOnInit() {
 	
 	}

}
